import { h, Component } from 'preact';
import { Router } from 'preact-router';
import { Match, Link } from 'preact-router/match';
import AsyncRoute from 'preact-async-route';

import Snackbar from 'preact-material-components/Snackbar';

import { Header } from './header/Header';
import { Home } from '../routes/home/home';
import { TakePictureComponent } from '../routes/takePicture/takePicture';
import { ServiceWorkerSvc } from '../services/ServiceWorkerSvc';
import { FormSampleComponent } from '../routes/formSample/formSample'
import { Register } from '../routes/register/register';
import { AuthApiService } from '../services/authapi.service';
//import { ScanCode } from '../routes/scanCode/scanCode'

//import Cookies from 'universal-cookie';
import { AuthService } from '../services/auth.service';
import { GuardedRoute } from './guardedRoute/guardedRoute';
import { BuildingApiService } from '../services/buildingapi.service';
import { SignInOut } from '../routes/signinout/signInOut';
import { ModalDialog } from './modalDialog/modalDialog';
import { SettingsComponent } from '../routes/settings/settings';
import { CommonService } from '../services/common.service';
import { version } from '../version';
import { Refresh } from './refresh/refresh';

//import 'preact-material-components/style.css';

export default class App extends Component<any, any> {

    private currentUrl: string;

    private auth: AuthService;
    private commonService: CommonService;

    public ver = version;

    private versionInterval: any;

    constructor(prefs, ctx) {
        super(prefs, ctx);

        //this.context.cookies = new Cookies();
        this.auth = new AuthService();//this.context.cookies);
        this.context.auth = this.auth;
        this.context.swsvc = new ServiceWorkerSvc();
        this.context.authService = new AuthApiService(this.auth);
        this.context.buildingService = new BuildingApiService(this.auth);
        this.commonService = new CommonService();
        this.context.commonService = this.commonService;

        this.setState({
            initDone: false,
            errorMessage: undefined,
            warningMessage: undefined
        });

        this.checkBrowser().then(msg => {
            console.log(msg);
            this.setState({
                initDone: true,
                errorMessage: !msg?"":msg.error,
                warningMessage: !msg?"":msg.warning
            });
            if (this.state.warningMessage) {
                console.log("asdasd");
                this.context.modal.alert(this.state.warningMessage);
                this.setState({ warningMessage: '' });
            }
            //if (!msg) {
            //    this.context.authService.getVersion().then((v) => {
            //        if (this.ver !== v) {
            //            location.reload(true);
            //        }
            //        else {
            //            this.setState({
            //                initDone: true
            //            });
            //        }
            //    });
            //}
        });

        console.log("Version: " + this.ver);

        window['pwaapp'] = this;
    }

    componentDidMount() {
        if (this.versionInterval) {
            clearInterval(this.versionInterval);
        }
        if (!(window as any).location.href.endsWith("/refresh/"))
            this.checkForNewVersion();
        this.versionInterval = setInterval(() => {
            this.checkForNewVersion();
        }, 3600000);
    }

    private checkForNewVersion() {
        this.context.authService.getVersion().then((v) => {
            if (this.ver !== v) {
                if (!this.context.modal) {
                    clearInterval(this.versionInterval);
                }
                else
                    this.context.modal.showSnackBar({
                        message: "New version is available!",
                        timeout: 10000,
                        multiline: true,
                        actionText: 'Refresh',
                        actionHandler: () => {
                            location.href = '/refresh/';
                        }
                    });
            }
        });
    }

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
    handleRoute = e => {
        this.currentUrl = e.url;
        console.log(e);
    };


    public checkBrowser(): Promise<any> {
        try {
            if (navigator.userAgent.indexOf("iPhone") > -1 || navigator.userAgent.indexOf("iPad") > -1 || navigator.userAgent.indexOf("iPod") > -1 || navigator.userAgent.indexOf("Android") > -1) {
                if (!navigator['serviceWorker'] || !navigator['mediaDevices'] || !navigator.mediaDevices['enumerateDevices']) {
                    return Promise.resolve(this.getWrongBrowserErrorMessage());
                }
                else if (navigator.userAgent.indexOf("Android") > -1 && !window['Notification']) {
                    return Promise.resolve(this.getWrongBrowserErrorMessage());
                }
                else {
                    return navigator.mediaDevices.enumerateDevices().then(devices => {
                        console.log(devices);
                        if (devices.some(d => d.kind.indexOf("video") > -1))
                            return Promise.resolve(undefined);
                        return Promise.resolve(this.getWrongBrowserErrorMessage());
                    })
                }
            }
            return Promise.resolve(undefined);
        }
        catch (e) {
            var msg = e;
            try {
                msg = JSON.stringify(e);
            }
            catch {
            }
            return Promise.resolve({ error: msg });
        }
    }

    public getWrongBrowserErrorMessage() {
        if (navigator.userAgent.indexOf("iPhone") > -1 || navigator.userAgent.indexOf("iPad") > -1 || navigator.userAgent.indexOf("iPod") > -1) { 

        var iOS = parseFloat(('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')) || false;

        if (iOS < 11.3) {
            return {
                //warning: 'Please update your phone iOS version to a minimum of 11.3 in order to continue.\n\n (Settings, General, Software Update)'
                warning: 'Please note that older IOS versions may not work correctly'
            }; 
        } else {
            return {
                error: 'Please use the iOS Camera app to scan the QR Code, or go to www.signin.to'
            };
        }


    } else if(navigator.userAgent.indexOf("Android")) {
            return {
                error: 'Please go to www.signin.to from your web browser'
            };
    }
}

    render() {
        return (
            <div id="app">
                <ModalDialog ref={d => { this.context.modal = d; }} />
                <div style={{ paddingTop: '64px', paddingBottom: '64px' }}>
                    {!this.state.initDone || this.state.errorMessage ? <h2>{this.state.errorMessage}</h2> :
                        <Router onChange={this.handleRoute}>
                            <GuardedRoute path="/" roles={["ApiAccess"]} component={Home} />
                            <GuardedRoute path="/documents/:docpath?" roles={["ApiAccess"]} component={Home} mode="documents" />
                            <GuardedRoute path="/workrequests/:workrequestid?" roles={["ApiAccess"]} component={Home} mode="workrequests" />
                            <GuardedRoute path="/b/:buildingId/:buildingName?" roles={["ApiAccess"]} component={Home} mode="signInOut" />
                            <TakePictureComponent path="/takePicture" />
                            <FormSampleComponent path="/formSample" />
                            <Register path="/register"></Register>
                            <Register path="/register-with-options" withOptions={true}></Register>
                            <GuardedRoute path="/settings/updateUser" roles={["ApiAccess"]} component={Register} mode="update" />
                            <GuardedRoute path="/scanCode" roles={["ApiAccess"]}>
                                <AsyncRoute
                                    path="/scanCode"
                                    getComponent={() => import('../routes/scanCode/scanCode').then(module => module.ScanCode)}
                                    loading={() => <div></div>}
                                />
                            </GuardedRoute>
                            <GuardedRoute path="/signout/:buildingId" roles={["ApiAccess"]} component={SignInOut} isSignIn={false} />
                            <GuardedRoute path="/signin/:buildingId/:buildingName?" roles={["ApiAccess"]} component={SignInOut} isSignIn={true} />
                            <GuardedRoute path="/settings/companyList" roles={["ApiAccess"]} component={SettingsComponent} />
                            <Refresh path="/refresh" />
                        </Router>}
                </div>
                <Header hideMenu={!this.state.initDone || this.state.errorMessage} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app.tsx